/* eslint-disable guard-for-in */
import React from "react";
import ResponseViewer from "../ResponseViewer";
import Table from "../Table";
import * as Constants from "../../constants/Constants";
import {findIdForKey} from "../../utils/helpers";

const SchemaContainer = ({title, schemas, propertiesTableData, requestBody, schemaIndex, navIndex, id}) => {
  // Function to extract types from an object and its nested properties
  const getTypes = (obj, parent, path = [], count = 0) => {
    const types = [];

    // Check if the object has a "$ref" property, indicating a reference link and maintaining count variable for arrows logic
    if (!obj?.type && obj?.["$ref"]) {
      types.push(`${path.join(".")} ^* ${parent ? parent : "object"} ^* ${obj?.["$ref"] ? "refLink/" + obj?.["$ref"].replace("#/components/schemas/", "")+"/"+findIdForKey(schemas, obj["$ref"].replace("#/components/schemas/", "")) : obj?.description && obj?.description} ^* ${count}`);
    } else if (obj?.type) {
      // If the object has a "type" property, include it in the types array
      types.push(`${path.join(".")} ^* ${obj?.type} ^* ${obj?.["$ref"] ? "refLink/" + obj["$ref"].replace("#/components/schemas/", "")+"/"+findIdForKey(schemas, obj["$ref"].replace("#/components/schemas/", "")): obj?.description && obj?.description} ^* ${count}`);
    }
    for (const key in obj) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        // Recursively call the function and increment the count
        types.push(...getTypes(obj[key], `${obj?.type ? obj?.type : ""}`, [...path, key], key==="properties" ? count+1 : count));
      }
    }
    return types;
  };

  const typesArray = getTypes((propertiesTableData?.properties || propertiesTableData?.items?.properties), "");

  // Process the types array into a more structured format
  const tableHeaderKeys = [Constants.Values.TABLE_HEADER_NAME, Constants.Values.TABLE_HEADER_TYPE];
  const processedArray = typesArray?.map((typeString) => {
    const [path, type, description, count] = typeString.split("^*").map((str) => str.trim());
    const levels = path.split(".");
    const lastName = levels[levels.length - 1];
    const name = lastName === "items" ? levels[levels.length - 2] : lastName;

    if (description !== Constants.Values.TYPE_UNDEFINED && !tableHeaderKeys.includes("Description")) {
      tableHeaderKeys.push("Description");
    }
    return {Name: name+"/"+count, Type: type || "object", ...(description !== Constants.Values.TYPE_UNDEFINED && {Description: description})};
  })
    .filter(({Type, Name}) => Type !== ""&& Name!== "" && !/^items(?:\/\d+)?$/.test(Name) && !/^(?:\/\d+)?$/.test(Name) && !/^properties(?:\/\d+)?$/.test(Name) && Type !== "undefined");

  // Create an array of unique objects by removing duplicates based on Name
  const uniqueObjects = [];
  processedArray.forEach((obj, index) => {
    if (index === 0 || obj.Name !== processedArray[index - 1].Name) {
      // Add the object to uniqueObjects if it's the first element or has a different Name than the previous one
      uniqueObjects.push(obj);
    } else if (obj.Type !== Constants.Values.TYPE_ARRAY && processedArray[index - 1].Type===Constants.Values.TYPE_ARRAY) {
      // Update the previous object in uniqueObjects with the Type wrapped in [ ]
      uniqueObjects[uniqueObjects.length - 1] = processedArray[index - 1].Description ? {...processedArray[index - 1], Type: `[${obj.Type}]`}: {...obj, Type: `[${obj.Type}]`};
    } else if (obj.Type===Constants.Values.TYPE_ARRAY) {
      uniqueObjects[uniqueObjects.length - 1] = obj;
    }
  });

  return (
    <>
      <div className="main-section">

        <h2 className="sidebar-link-text schemas" id={id} data-index={schemaIndex} data-open-index={navIndex} data-id={title}>
          <span className="sidebar-link-text">{title}</span>
        </h2>
        <div className="method-example-part example-request">
          <ResponseViewer data={requestBody} type={Constants.Values.TABLE_NAME_BODY_PARAMETER}/>
        </div>
        <h3 id="properties-2">Properties</h3>
        <Table data={uniqueObjects} tableName={Constants.Values.TABLE_NAME_PROPERTIES} tableHeaderKeys={tableHeaderKeys} />
      </div>
    </>
  );
};

export default SchemaContainer;
